/* @flow */
import MessageDelivery from 'entities/MessageDelivery';
import Collection from 'lib/Collection';

class MessageDeliveries extends Collection<MessageDelivery> {
  initialize() {
    this.model = MessageDelivery;
  }

  findWhereMessageId(messageId: Backbone$Id) {
    return this.findWhere({ message_uuid: messageId });
  }
}

export default MessageDeliveries;
